import { getSkillsByFaction } from '@shared/skillDefs';
export class HUD {
    faction;
    minimapCtx;
    currentPanel = null;
    constructor(faction) {
        this.faction = faction;
        this.initSkillBar();
        this.initPKToggle();
        this.initChatInput();
        this.initPanels();
        const minimapCanvas = document.getElementById('minimapCanvas');
        this.minimapCtx = minimapCanvas.getContext('2d');
    }
    // ===== 技能栏初始化 =====
    initSkillBar() {
        const skillBar = document.getElementById('skillBar');
        const skills = getSkillsByFaction(this.faction);
        const keys = ['空格', '1', '2', '3', '4', '5'];
        skills.forEach((skill, i) => {
            const slot = document.createElement('div');
            slot.className = 'skill-slot';
            slot.title = `${skill.name}\n${skill.description}\n冷却: ${skill.cooldown}s | 内力: ${skill.mpCost}\n需要等级: ${skill.levelReq}`;
            slot.innerHTML = `
        <span class="key">${keys[i] || ''}</span>
        <span class="skill-name">${skill.name.slice(0, 2)}<br/>${skill.name.slice(2) || ''}</span>
      `;
            skillBar.appendChild(slot);
        });
    }
    // ===== PK 开关 =====
    initPKToggle() {
        const pkToggle = document.getElementById('pkToggle');
        let pkOn = false;
        pkToggle.addEventListener('click', () => {
            pkOn = !pkOn;
            pkToggle.className = pkOn ? 'pk-toggle pk-on' : 'pk-toggle pk-off';
            pkToggle.textContent = pkOn ? 'PK 模式' : '和平模式';
            window.dispatchEvent(new CustomEvent('toggle_pk'));
        });
    }
    // ===== 聊天 =====
    initChatInput() {
        document.getElementById('chatSend').addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('send_chat'));
        });
    }
    sendChat(network) {
        const input = document.getElementById('chatInput');
        const content = input.value.trim();
        if (content) {
            network.sendChat(content);
            input.value = '';
        }
        input.blur();
    }
    addChatMessage(name, content) {
        const messages = document.getElementById('chatMessages');
        const p = document.createElement('p');
        p.innerHTML = `<span class="name-tag">[${name}]</span> ${this.escapeHtml(content)}`;
        messages.appendChild(p);
        messages.scrollTop = messages.scrollHeight;
        while (messages.children.length > 50) {
            messages.removeChild(messages.firstChild);
        }
    }
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
    // ===== 面板系统 =====
    initPanels() {
        // 底部按钮栏
        const btns = document.querySelectorAll('.panel-btn');
        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                const panel = btn.getAttribute('data-panel');
                this.togglePanel(panel);
            });
        });
        // 关闭按钮
        document.querySelectorAll('.panel-close').forEach(btn => {
            btn.addEventListener('click', () => {
                this.closePanel();
            });
        });
        this.buildCharacterPanel();
        this.buildSkillPanel();
        this.buildInventoryPanel();
    }
    togglePanel(name) {
        if (this.currentPanel === name) {
            this.closePanel();
            return;
        }
        this.closePanel();
        const el = document.getElementById(`panel-${name}`);
        if (el) {
            el.style.display = 'block';
            this.currentPanel = name;
        }
    }
    closePanel() {
        if (this.currentPanel) {
            const el = document.getElementById(`panel-${this.currentPanel}`);
            if (el)
                el.style.display = 'none';
        }
        this.currentPanel = null;
    }
    buildCharacterPanel() {
        const body = document.getElementById('charPanelBody');
        body.innerHTML = `
      <div class="char-avatar">
        <div class="avatar-placeholder"></div>
      </div>
      <div class="char-stats">
        <div class="stat-row"><span>攻击力</span><span id="statAtk">--</span></div>
        <div class="stat-row"><span>防御力</span><span id="statDef">--</span></div>
        <div class="stat-row"><span>法术强度</span><span id="statSpell">--</span></div>
        <div class="stat-row"><span>法术抗性</span><span id="statRes">--</span></div>
        <div class="stat-row"><span>暴击率</span><span id="statCrit">--</span></div>
        <div class="stat-row"><span>暴击伤害</span><span id="statCdmg">--</span></div>
        <div class="stat-row"><span>移动速度</span><span id="statSpeed">--</span></div>
      </div>
      <div class="equip-slots">
        <div class="equip-label">装备栏</div>
        <div class="equip-grid">
          <div class="equip-slot" title="武器">武</div>
          <div class="equip-slot" title="头盔">盔</div>
          <div class="equip-slot" title="铠甲">甲</div>
          <div class="equip-slot" title="护腿">腿</div>
          <div class="equip-slot" title="鞋子">靴</div>
          <div class="equip-slot" title="饰品">饰</div>
        </div>
      </div>
    `;
    }
    buildSkillPanel() {
        const body = document.getElementById('skillPanelBody');
        const skills = getSkillsByFaction(this.faction);
        const keys = ['空格', '1', '2', '3', '4', '5'];
        body.innerHTML = skills.map((s, i) => `
      <div class="skill-detail">
        <div class="skill-icon-big">${s.name.slice(0, 1)}</div>
        <div class="skill-info">
          <div class="skill-title">${s.name} <span class="skill-key-tag">${keys[i]}</span></div>
          <div class="skill-desc">${s.description}</div>
          <div class="skill-meta">
            冷却: ${s.cooldown}s | 内力: ${s.mpCost} | 等级需求: Lv.${s.levelReq}
            ${s.damageRatio > 0 ? ` | 伤害倍率: ${s.damageRatio}x` : ''}
          </div>
        </div>
      </div>
    `).join('');
    }
    buildInventoryPanel() {
        const body = document.getElementById('invPanelBody');
        let grid = '<div class="inv-grid">';
        for (let i = 0; i < 24; i++) {
            grid += '<div class="inv-slot"></div>';
        }
        grid += '</div>';
        body.innerHTML = `<p class="inv-hint">背包 (暂无物品)</p>${grid}`;
    }
    // ===== 更新角色面板属性 =====
    updateCharStats(data) {
        const set = (id, val) => {
            const el = document.getElementById(id);
            if (el)
                el.textContent = val;
        };
        set('statAtk', `${data.atk || '--'}`);
        set('statDef', `${data.def || '--'}`);
        set('statSpell', `${data.spell || '--'}`);
        set('statRes', `${data.res || '--'}`);
        set('statCrit', `${((data.crit || 0) * 100).toFixed(1)}%`);
        set('statCdmg', `${((data.cdmg || 1.5) * 100).toFixed(0)}%`);
        set('statSpeed', `${data.speed || '--'}`);
    }
    // ===== 玩家信息更新 =====
    updatePlayerInfo(name, level) {
        document.getElementById('hudName').textContent = name;
        document.getElementById('hudLevel').textContent = `Lv.${level}`;
    }
    updateHP(hp, maxHp) {
        const ratio = Math.max(0, hp / maxHp) * 100;
        document.getElementById('hpBar').style.width = `${ratio}%`;
        document.getElementById('hpText').textContent = `${Math.max(0, Math.floor(hp))}/${maxHp}`;
    }
    updateMP(mp, maxMp) {
        const ratio = Math.max(0, mp / maxMp) * 100;
        document.getElementById('mpBar').style.width = `${ratio}%`;
        document.getElementById('mpText').textContent = `${Math.max(0, Math.floor(mp))}/${maxMp}`;
    }
    // ===== 目标信息 =====
    showTarget(name, hp, maxHp) {
        const el = document.getElementById('targetInfo');
        el.style.display = 'block';
        document.getElementById('targetName').textContent = name;
        const ratio = Math.max(0, hp / maxHp) * 100;
        document.getElementById('targetHpBar').style.width = `${ratio}%`;
        document.getElementById('targetHpText').textContent = `${Math.max(0, Math.floor(hp))}/${maxHp}`;
    }
    hideTarget() {
        document.getElementById('targetInfo').style.display = 'none';
    }
    // ===== 伤害飘字 =====
    showDamagePopup(damage, isCrit, screenPos) {
        const el = document.createElement('div');
        el.className = `damage-popup ${isCrit ? 'damage-crit' : 'damage-normal'}`;
        el.textContent = isCrit ? `${damage}!` : `-${damage}`;
        el.style.left = `${screenPos.x + (Math.random() - 0.5) * 40}px`;
        el.style.top = `${screenPos.y}px`;
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 1200);
    }
    // ===== 击杀通知 =====
    showKillNotice(killerName, deadName) {
        const el = document.createElement('div');
        el.className = 'kill-notice';
        el.textContent = `${killerName} 击杀了 ${deadName}`;
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 3000);
    }
    // ===== 小地图 =====
    updateMinimap(playerPos, remotePlayers, monsters) {
        const ctx = this.minimapCtx;
        const w = 160, h = 160;
        const scale = 0.8;
        const cx = w / 2;
        const cy = h / 2;
        ctx.fillStyle = 'rgba(10, 20, 30, 0.9)';
        ctx.fillRect(0, 0, w, h);
        ctx.strokeStyle = '#333';
        ctx.strokeRect(2, 2, w - 4, h - 4);
        ctx.fillStyle = '#00ff00';
        ctx.beginPath();
        ctx.arc(cx, cy, 3, 0, Math.PI * 2);
        ctx.fill();
        remotePlayers.forEach((rp) => {
            const dx = (rp.mesh.position.x - playerPos.x) * scale;
            const dz = (rp.mesh.position.z - playerPos.z) * scale;
            const sx = cx + dx;
            const sy = cy - dz;
            if (sx > 0 && sx < w && sy > 0 && sy < h) {
                ctx.fillStyle = '#4488ff';
                ctx.beginPath();
                ctx.arc(sx, sy, 2, 0, Math.PI * 2);
                ctx.fill();
            }
        });
        monsters.forEach((m) => {
            const dx = (m.mesh.position.x - playerPos.x) * scale;
            const dz = (m.mesh.position.z - playerPos.z) * scale;
            const sx = cx + dx;
            const sy = cy - dz;
            if (sx > 0 && sx < w && sy > 0 && sy < h) {
                ctx.fillStyle = m.type === 'boss_tiger' ? '#ff8800' : '#ff3333';
                ctx.beginPath();
                ctx.arc(sx, sy, m.type === 'boss_tiger' ? 4 : 2, 0, Math.PI * 2);
                ctx.fill();
            }
        });
        ctx.fillStyle = '#888';
        ctx.font = '10px monospace';
        ctx.fillText(`${Math.floor(playerPos.x)}, ${Math.floor(playerPos.z)}`, 4, h - 4);
    }
}
